import { IFloatLocationModel } from "./floatLocationModel";

export class IUserAppointmentSettingsModel {
    UserId: number = 0;
    SecondaryNotificationEmail: string = '';
    SecondaryEmailAsOptionalAttendee: boolean = false;
    PreferredTimeZone: number = 0;
    OptInDailyUserSummaryEmail: boolean = false;
    OptInDailyBranchSummaryEmail: boolean = false;
    RestrictAvailabilityOperatingHours: boolean = false;
    IsFloat: boolean = false;
    FloatLocations: IFloatLocationModel[] = [];
    EligibleForInPersonAppointments: boolean = false;
    EligibleForPhoneAppointments: boolean = false;
    EligibleForVirtualAppointments: boolean = false;
    AppointmentsEnabled: boolean = false;
    AssignmentRank: number = 0;
    EventsEnabled: boolean = false;
    VirtualConferencingUserId: string = '';
    VirtualConferencingRefreshToken: string = '';
    VirtualConferencingRefreshTokenSavedOn?: Date;
}
